import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import CssBaseline from "@mui/material/CssBaseline";
ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  // <ThemeProvider theme={theme}>
  //   <App />
  // </ThemeProvider>
  // </React.StrictMode>
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);